import React from 'react';
import { getStatusColor } from '../../utils/helpers';

const StatusBadge = ({ status }) => {
  if (!status) return <span className="text-muted">—</span>;
  return (
    <span className={`status-badge ${status.toLowerCase()}`}>
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
};

export default StatusBadge;
